import React from "react";

import styles from "./Banner.module.scss";
import { useNavigate } from "react-router-dom";

const LeaderboardBanner = ({ redirectUrl, altText, imageUrl }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.leaderboardBannerContainer}>
      <img
        src={imageUrl}
        alt={altText || ""}
        style={{ cursor: redirectUrl ? "pointer" : "default" }}
        onClick={() => {
          if (redirectUrl) {
            const url = redirectUrl?.replace(
              process.env.REACT_APP_WEB_BASE_PATH,
              ""
            );

            navigate(url);
          }
        }}
      />
    </div>
  );
};

export default LeaderboardBanner;
